module.exports = __webpack_public_path__ + "static/media/Carnivine_gaussian2.5e2f5d38.png";